<template>
  <div class="cart font-body">
    <StoreHeader type="cart" />

    <main>
      <slot />
    </main>

    <!-- Modals -->
    <ModalLogin />
  </div>
</template>

<script setup>
const head = useLocaleHead({
  addDirAttribute: true,
});

const headAndMeta = useHeadAndMeta();

// head is a reactive ref.
useHead(head);

// Static metadata
useHead(headAndMeta);
</script>

<style>
.cart {
  @apply bg-gray-200;
  @apply sm:bg-white;
}
</style>
